import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { useIntl } from "react-intl";

import { ApiError, useApi } from "@dzambalaorg/provider-api-firebase";

export function useMutationQuery<T extends Record<string, any>>(
  url: string,
  method: "POST" | "PUT" | "DELETE",
  settings?: {
    showSuccess?: boolean;
    showError?: boolean;
    onSuccess?: () => void;
    onError?: () => void;
  },
): UseMutationResult<any, ApiError, T, unknown> {
  const { showSuccess = false, showError = true, onSuccess, onError } = settings || {};
  const { enqueueSnackbar } = useSnackbar();
  const { formatMessage } = useIntl();
  const api = useApi();

  return useMutation({
    mutationFn: (data: T) =>
      api.fetchJson({
        url,
        method,
        data,
      }),
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
      if (showSuccess) {
        enqueueSnackbar(formatMessage({ id: "snackbar.success" }), { variant: "success" });
      }
    },
    onError: (e: ApiError) => {
      if (onError) {
        onError();
      }
      if (!showError) return;
      if (e.status === 400) {
        if (typeof e.message === "string") {
          enqueueSnackbar(formatMessage({ id: `snackbar.${e.message}` }), { variant: "error" });
        } else {
          enqueueSnackbar(formatMessage({ id: "snackbar.badRequest" }), { variant: "error" });
        }

        // const errors = e.getLocalizedValidationErrors();
      } else if (e.status) {
        enqueueSnackbar(formatMessage({ id: `snackbar.${e.message}` }), { variant: "error" });
      } else {
        console.error(e);
        enqueueSnackbar(formatMessage({ id: "snackbar.error" }), { variant: "error" });
      }
    },
  });
}
